/*
 * @Author: Mingzhi.Li
 * @Date: 2018-05-15 11:59:38
 * @Last Modified by: Mingzhi.Li
 * @Last Modified time: 2018-05-16 17:33:10
 */

import request from './request';

class Api {
	// 用户信息
	static getUserInfo(data,options) {
		return request.post(Object.assign({data},options,{url: '/activity/vitality/get_user_info'}));
	}
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/apiMillionaire.js